var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('ticker',{attrs:{"Ticker":_vm.ticker},on:{"export":_vm.get_csv,"send_link":_vm.get_link}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }